<template>
  <div>
    <template v-if="node.children.length === 0">
      <vl-checkbox @click="check(node.key)">{{ node.key }}</vl-checkbox>
    </template>
    <template v-else>
      <div class="toggle-container" @click="toggleHidden">
        <vl-icon-wrapper v-vl-spacer:top>
          <vl-icon :icon="hiddenIcon" mod-before></vl-icon>
          <vl-icon icon="folder" mod-light mod-before></vl-icon>
          <vl-annotation>{{ node.key }}</vl-annotation>
        </vl-icon-wrapper>
      </div>

      <div v-show="!hidden" v-vl-spacer:left v-vl-spacer:top>
        <dl-folder-node-component :rootNode="node" @check="check"></dl-folder-node-component>
      </div>
    </template>
  </div>
</template>

<script src="./dl-folder-accordion-component.ts" lang="ts"></script>

<style lang="scss" scoped src="./dl-folder-accordion-component.scss"></style>
